<template>
    <div v-if="ready" class="mt-3">
        <h5 class="mb-3">{{ sectionTitle }}</h5>
        <b-form-checkbox
            v-model="form.chief_renewed"
            switch
            class="mb-2"
            @change="updateSwitch('chief_renewed')"
        >
            {{ labels.chief_renewed }}
        </b-form-checkbox>
        <b-form-checkbox
            v-model="form.chief_replaced"
            switch
            class="mb-2"
            @change="updateSwitch('chief_replaced')"
        >
            {{ labels.chief_replaced }}
        </b-form-checkbox>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import ToastHandler from '../../../../common/mixins/ToastHandler.vue'

export default {
    name: 'ChiefMandateSwitches',

    mixins: [ToastHandler],

    data() {
        return {
            ready: false,
            labels: {
                chief_renewed: '',
                chief_replaced: '',
            },
            form: {
                chief_renewed: false,
                chief_replaced: false,
            },
            sectionTitle: 'Décisions AG — Gérance',
        }
    },

    computed: {
        ...mapState({
            client: (state) => state.legalVM.client,
            year: (state) => state.browsing.year,
        }),

        presidentChiefRoleValues() {
            return [
                'president',
                'board_chair',
                'management_board_chair',
                'management_committee_chair',
            ]
        },

        usesPresidenceFromChiefs() {
            const chiefs = this.client?.chiefs?.data ?? []

            return chiefs.some((chief) => {
                if (
                    this.presidentChiefRoleValues.includes(chief.chief_role)
                ) {
                    return true
                }

                const title = (chief.chief_title || '').toLowerCase()

                return (
                    title.includes('président') || title.includes('president')
                )
            })
        },

        usesPresidenceFromLegalForm() {
            return ['SAS', 'SASU', 'SA'].includes(
                (this.client?.legal_form || '').toUpperCase()
            )
        },

        usesPresidence() {
            return (
                this.usesPresidenceFromChiefs || this.usesPresidenceFromLegalForm
            )
        },

        exerciseYear() {
            const y = this.year ?? new Date().getFullYear()

            return y - 1
        },
    },

    async created() {
        await this.loadKeyFigures()
    },

    methods: {
        async loadKeyFigures() {
            try {
                const response = await axios.get(
                    `/legal/clients/${this.client.id}/keyFigures/${this.exerciseYear}`
                )
                const cur = response.data?.data?.current_exercise || {}
                const extendedLabels =
                    response.data?.meta?.extended_data_labels || {}

                this.sectionTitle =
                    response.data?.meta?.chief_mandate_section_title ||
                    (this.usesPresidence
                        ? 'Décisions AG — Présidence'
                        : 'Décisions AG — Gérance')

                this.labels = {
                    chief_renewed: extendedLabels.chief_renewed || '',
                    chief_replaced: extendedLabels.chief_replaced || '',
                }
                this.form.chief_renewed = !!cur.chief_renewed
                this.form.chief_replaced = !!cur.chief_replaced
                this.ready = true
            } catch (error) {
                console.error(error)
            }
        },

        async updateSwitch(field) {
            this.showRecordingToast()
            try {
                await axios.put(
                    `/legal/clients/${this.client.id}/keyFigures/${this.exerciseYear}/extended-data`,
                    {
                        [field]: !!this.form[field],
                    }
                )
                await this.loadKeyFigures()
                this.handleSuccess('Valeur enregistrée')
            } catch (error) {
                this.handleErrors(error?.response?.status)
                await this.loadKeyFigures()
            }
        },
    },
}
</script>
